function getCommissionDisclosureLink(planId: number): string {
  const disclosureSection = '#detail--free-look-and-agent-compensation-disclosure'

  return `/product/short-term-health-insurance/details/?planid=${planId}${disclosureSection}`
}

export default getCommissionDisclosureLink
